import axios from 'axios';
import {toast} from 'react-toastify';

// Configure axios defaults
axios.defaults.timeout = 30000; // 30 second timeout
axios.defaults.headers.common['Content-Type'] = 'application/json';


//axios.defaults.headers.common['x-auth-token'] = auth.getJwt();


//axios.interceptors.response.use(success,error);
axios.interceptors.response.use(null,error=>{
    const expectedError = error.response &&
        error.response.status >= 400 &&
        error.response.status < 500;
        
    if(expectedError) {
        if(error.response.status === 403) toast.error('Access Denied');
    } else {
        // Handle different types of network errors
        if (error.code === 'NETWORK_ERROR' || error.code === 'ERR_NETWORK') {
            toast.error('Could not connect to the server. Please check your internet connection.');
        } else if (error.code === 'ECONNABORTED') {
            toast.error('Request timeout. The server took too long to respond.');
        } else if (!error.response) {
            toast.error('Network error. Could not reach the server.');
        } else {
            toast.error('Unexpected server error occurred.');
        }
    }
  
    return Promise.reject(error);
});

  function setJwt(jwt) {
 
 axios.defaults.headers.common["x-auth-token"] = jwt;
    //axios.defaults.headers.post['Content-Type'] = 'application/json';
  }
  export default {
      get: axios.get,
      post: axios.post,
      put: axios.put,
      patch: axios.patch,
      delete: axios.delete,
      setJwt
  };